import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {ExpenseStatus} from "../../types/expenses-status.type";

export class ExpenseStatusesMultiSelectListCtrl implements IController {
  statuses: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;
  private queryString: any;
  private expenseStatuses = Object.values(ExpenseStatus);

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = this.expenseStatuses;
    }
  }

  $onChanges(changes) {
    if (changes.statuses) {
      this.selectedKeys = [];
      _.forEach(this.statuses, (type) => {
        this.selectedKeys[type] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      statuses: isSelected ? _.concat(this.statuses, [option]) :
        _.filter(this.statuses, (type) => {
          return type !== option;
        })
    });
  }

  onReset() {
    this.onChange({statuses: []});
  }

  submitQuery(query) {
    this.queryString = query;
  }

}

angular
  .module('bringoz.admin.expenses')
  .component('expenseStatusesMultiSelectList', {
    bindings: {
      statuses: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./expense-statuses-multi-select-list.html').default,
    controller: ExpenseStatusesMultiSelectListCtrl
  });
